// ─────────────────────────────────────────────────────────────────
// Glass-i — Supplier Master frontend constants (Stage 6B.3).
//
// Display labels + AntD option lists. Keep in lockstep with
// backend/src/services/erp/suppliers/supplier.constants.js.
// ─────────────────────────────────────────────────────────────────

export const SUPPLIER_STATUS_OPTIONS = [
  { value: 'active',   label: 'Active'   },
  { value: 'inactive', label: 'Inactive' },
  { value: 'blocked',  label: 'Blocked'  }
];

export const SUPPLIER_TYPE_OPTIONS = [
  { value: 'business',    label: 'Business'    },
  { value: 'individual',  label: 'Individual'  },
  { value: 'government',  label: 'Government'  },
  { value: 'foreign',     label: 'Foreign'     }
];

export const GST_REGISTRATION_TYPE_OPTIONS = [
  { value: 'registered_regular',    label: 'Registered (Regular)' },
  { value: 'registered_composition', label: 'Composition' },
  { value: 'unregistered',          label: 'Unregistered (URP)' },
  { value: 'consumer',              label: 'Consumer' },
  { value: 'sez',                   label: 'SEZ' },
  { value: 'export',                label: 'Export' },
  { value: 'deemed_export',         label: 'Deemed Export' }
];

export const ADDRESS_TYPE_OPTIONS = [
  { value: 'billing',    label: 'Billing'    },
  { value: 'shipping',   label: 'Shipping'   },
  { value: 'warehouse',  label: 'Warehouse'  },
  { value: 'branch',     label: 'Branch'     },
  { value: 'registered', label: 'Registered' },
  { value: 'other',      label: 'Other'      }
];

export const STATUS_COLOR = {
  active:   'green',
  inactive: 'default',
  blocked:  'red'
};

export const REGISTRATION_TYPES_REQUIRING_GSTIN = new Set([
  'registered_regular',
  'registered_composition',
  'sez'
]);

// Validation regex mirroring backend (used for inline form hints).
export const GSTIN_RE   = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z][1-9A-Z][A-Z][0-9A-Z]$/;
export const PAN_RE     = /^[A-Z]{5}[0-9]{4}[A-Z]$/;
export const MOBILE_RE  = /^[6-9][0-9]{9}$/;
export const PINCODE_RE = /^[0-9]{6}$/;
export const IFSC_RE    = /^[A-Z]{4}0[A-Z0-9]{6}$/;
export const UDYAM_RE   = /^UDYAM-[A-Z]{2}-[0-9]{2}-[0-9]{7}$/;
